import uiConf from "../../config/uiConf";
import apiClient from "../../lib/common/apiClient";
import CustomButtonLayout from "../layout/CustomButtonLayout";

/**
 * @COMPONENT_NAME BarcodePrintButton
 * @DESCRIPTION 바코드 출력 버튼 컴포넌트. 바코드 정보를 기반으로 바코드 출력 리포트를 생성하고 
 *              새 창에서 출력용 HTML을 표시합니다. BarcodeReport API를 호출하여 바코드를 발급하고
 *              출력 양식에 맞춰 HTML 리포트를 생성합니다.
 *
 * @PASSTHROUGH_PROPS
 *   - {Array} barcodeInfos - 바코드 발급 정보 배열 (lotNo, machineCode, username 등 포함)
 *   - {String} barcodeIssueTarget - 바코드 발급 대상 타입 ("lot", "machine", "worker")
 *   - {String} barcodeUsage - 바코드 사용 용도 (BarcodeGenerateRule 테이블 조회용)
 *   - {Object} others - CustomButtonLayout으로 전달될 기타 props
 *
 * @CALLBACKS
 *   - {Function} onFailure - API 호출 실패 시 실행될 콜백 함수
 */
function BarcodePrintButton(props) {
    const { barcodeInfos, barcodeIssueTarget, barcodeUsage, onFailure, ...others } = props;

    const onClick = () => {
        let newWindow;

        let left = window.screen.width / 2 - uiConf.reportWindowWidth / 2;
        let top = window.screen.height / 2 - uiConf.reportWindowHeight / 2;

        let url =
            process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging"
                ? `/report/BarcodeReport/${barcodeIssueTarget.toLowerCase()}`
                : `http://localhost:8080/report/BarcodeReport/${barcodeIssueTarget.toLowerCase()}`;

        let form = new FormData();
        let apiData = { barcodeInfos, barcodeUsage };

        form.append("deleted", []);
        form.append("json", JSON.stringify(apiData));

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                const blob = new Blob([response.data], { type: "text/html;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                newWindow = window.open(
                    url,
                    "",
                    `width=${uiConf.reportWindowWidth * 1.5},height=${
                        uiConf.reportWindowHeight * 1.5
                    }, top=${top}, left=${left}`
                );
                newWindow.focus();
            })
            .catch((error) => {
                if (onFailure) {
                    onFailure(error);
                }
            });
    };

    return (
        <>
            <CustomButtonLayout buttonName="buttonName.barcodePrint" {...others} onClick={onClick} />
        </>
    );
}

export default BarcodePrintButton;
